import httpClient from './httpClient';
import { API_CONFIG } from './index';

class ColorsService {
  // Get all colors with optional filtering
  async getColors(filters = {}) {
    try {
      let endpoint = '/api/admin/colors';
      const queryParams = new URLSearchParams();
      
      if (filters.search) {
        queryParams.append('search', filters.search);
      }
      
      if (filters.combined_with) {
        queryParams.append('combined_with', filters.combined_with);
      }
      
      if (queryParams.toString()) {
        endpoint += `?${queryParams.toString()}`;
      }
      
      console.log('ColorsService: Making request to', endpoint);
      console.log('ColorsService: Full URL will be:', API_CONFIG.BASE_URL + endpoint);
      console.log('ColorsService: Filters:', filters);
      
      const response = await httpClient.get(endpoint);
      console.log('ColorsService: Raw response from httpClient:', response);
      console.log('ColorsService: Response type:', typeof response);
      console.log('ColorsService: Response keys:', Object.keys(response || {}));
      
      return response;
    } catch (error) {
      console.error('ColorsService: Error in getColors:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب الألوان'
      };
    }
  }

  // Create new color
  async createColor(colorData) {
    try {
      console.log('ColorsService: Received colorData:', colorData);
      
      // Create FormData for the request
      const formData = new FormData();
      formData.append('name', colorData.name);
      formData.append('hash_code', colorData.hash_code);
      if (colorData.combined_with) {
        formData.append('combined_with', colorData.combined_with);
      }

      console.log('ColorsService: Sending as FormData');
      console.log('ColorsService: FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      console.log('ColorsService: Making POST request to /api/admin/colors');
      const response = await httpClient.post('/api/admin/colors', formData);
      console.log('ColorsService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('Error creating color:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء إنشاء اللون'
      };
    }
  }

  // Update color
  async updateColor(id, colorData) {
    try {
      // Create FormData for the request
      const formData = new FormData();
      formData.append('name', colorData.name);
      formData.append('hash_code', colorData.hash_code);
      if (colorData.combined_with) {
        formData.append('combined_with', colorData.combined_with);
      }
      
      // Add _method field for Laravel to recognize this as PUT request
      formData.append('_method', 'PUT');

      console.log('ColorsService: Updating color', id, 'with FormData');
      console.log('ColorsService: FormData contents:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      console.log('ColorsService: Making POST request to /api/admin/colors/' + id + ' with _method=PUT');
      const response = await httpClient.post(`/api/admin/colors/${id}`, formData);
      console.log('ColorsService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('Error updating color:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء تحديث اللون'
      };
    }
  }

  // Delete color
  async deleteColor(id) {
    try {
      console.log('ColorsService: Deleting color', id);
      const response = await httpClient.delete(`/api/admin/colors/${id}`);
      console.log('ColorsService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('Error deleting color:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء حذف اللون'
      };
    }
  }

  // Get color by ID
  async getColorById(id) {
    try {
      console.log('ColorsService: Getting color by ID', id);
      const response = await httpClient.get(`/api/admin/colors/${id}`);
      console.log('ColorsService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('Error getting color by ID:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب اللون'
      };
    }
  }
}

export default new ColorsService();
